export const apartmentsList = [
  // {
  //   image: '/assets/images/apartments/18,2(1).png',
  //   title: 'Студия, 18,2 м²',
  //   price: '______',
  //   commonSpace: '18,2 м²',
  //   livingSpace: '8,01 м²',
  //   dialogTitle: 'Студия',
  // },
  // {
  //   image: '/assets/images/apartments/19,72(1).png',
  //   title: 'Студия, 19,72 м²',
  //   price: '______',
  //   commonSpace: '19,72 м²',
  //   livingSpace: '8,01 м²',
  //   dialogTitle: 'Студия',
  // },
  // {
  //   image: '/assets/images/apartments/22,26(2)_1.png',
  //   title: 'Студия, 22,26 м²',
  //   price: '______',
  //   commonSpace: '22,26 м²',
  //   livingSpace: '8,31 м²',
  //   dialogTitle: 'Студия',
  // },
  // {
  //   image: '/assets/images/apartments/22,26(2).png',
  //   title: 'Студия, 22,26 м²',
  //   price: '______',
  //   commonSpace: '22,26 м²',
  //   livingSpace: '8,31 м²',
  //   dialogTitle: 'Студия',
  // },
  // {
  //   image: '/assets/images/apartments/22,26(3)_1.png',
  //   title: 'Студия, 22,26 м²',
  //   price: '______',
  //   commonSpace: '22,26 м²',
  //   livingSpace: '8,31 м²',
  //   dialogTitle: 'Студия',
  // },
  // {
  //   image: '/assets/images/apartments/22,26(3).png',
  //   title: 'Студия, 22,26 м²',
  //   price: '______',
  //   commonSpace: '22,26 м²',
  //   livingSpace: '8,31 м²',
  //   dialogTitle: 'Студия',
  // },
  // {
  //   image: '/assets/images/apartments/1с_22,61.png',
  //   title: 'Студия, 22,61 м²',
  //   price: '______',
  //   commonSpace: '22,61 м²',
  //   livingSpace: '9,73 м²',
  //   dialogTitle: 'Студия',
  // },
  {
    image: '/assets/images/apartments/23,85.png',
    title: 'Студия, 23,85 м²',
    price: '______',
    commonSpace: '23,85 м²',
    livingSpace: '12,30 м²',
    dialogTitle: 'Студия',
  },
  {
    image: '/assets/images/apartments/4с_25,72.png',
    title: 'Студия, 25,72 м²',
    price: '______',
    commonSpace: '25,72 м²',
    livingSpace: '12,04 м²',
    dialogTitle: 'Студия',
  },
  // {
  //   image: '/assets/images/apartments/23,79(2)_1.png',
  //   title: 'Студия, 23,79 м²',
  //   price: '______',
  //   commonSpace: '23,79 м²',
  //   livingSpace: '8,31 м²',
  //   dialogTitle: 'Студия',
  // },
  // {
  //   image: '/assets/images/apartments/23,79(2).png',
  //   title: 'Студия, 23,79 м²',
  //   price: '______',
  //   commonSpace: '23,79 м²',
  //   livingSpace: '8,31 м²',
  //   dialogTitle: 'Студия',
  // },
  // {
  //   image: '/assets/images/apartments/23,79(3,1).png',
  //   title: 'Студия, 23,79 м²',
  //   price: '______',
  //   commonSpace: '23,79 м²',
  //   livingSpace: '8,31 м²',
  //   dialogTitle: 'Студия',
  // },
  // {
  //   image: '/assets/images/apartments/23,79(3).png',
  //   title: 'Студия, 23,79 м²',
  //   price: '______',
  //   commonSpace: '23,79 м²',
  //   livingSpace: '8,31 м²',
  //   dialogTitle: 'Студия',
  // },

  // {
  //   image: '/assets/images/apartments/26,90(4).png',
  //   title: 'Студия, 26,90 м²',
  //   price: '______',
  //   commonSpace: '26,90 м²',
  //   livingSpace: '8,41 м²',
  //   dialogTitle: 'Студия',
  // },
  {
    image: '/assets/images/apartments/1с_35,09.png',
    title: '1-комнатная, 35,09 м²',
    price: '______',
    commonSpace: '35,09 м²',
    livingSpace: '14,98 м²',
    dialogTitle: 'Однокомнатная квартира',
  },
  {
    image: '/assets/images/apartments/2с_36,82.png',
    title: '1-комнатная, 36,82 м²',
    price: '______',
    commonSpace: '36,82 м²',
    livingSpace: '15,29 м²',
    dialogTitle: 'Однокомнатная квартира',
  },
  // {
  //   image: '/assets/images/apartments/3с_31,53.png',
  //   title: '1-комнатная, 31,53 м²',
  //   price: '______',
  //   commonSpace: '31,53 м²',
  //   livingSpace: '12,20 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/35,66(3).png',
  //   title: '1-комнатная, 35,66 м²',
  //   price: '______',
  //   commonSpace: '35,66 м²',
  //   livingSpace: '16,48 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/35,72(4).png',
  //   title: '1-комнатная, 35,72 м²',
  //   price: '______',
  //   commonSpace: '35,72 м²',
  //   livingSpace: '19,52 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/35,90(2).png',
  //   title: '1-комнатная, 35,90 м²',
  //   price: '______',
  //   commonSpace: '35,90 м²',
  //   livingSpace: '16,73 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/35,90(3).png',
  //   title: '1-комнатная, 35,90 м²',
  //   price: '______',
  //   commonSpace: '35,90 м²',
  //   livingSpace: '16,73 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/36,13(1).png',
  //   title: '1-комнатная, 36,13 м²',
  //   price: '______',
  //   commonSpace: '36,13 м²',
  //   livingSpace: '11,9 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/37,06(2).png',
  //   title: '1-комнатная, 37,06 м²',
  //   price: '______',
  //   commonSpace: '37,06 м²',
  //   livingSpace: '16,48 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/37,07(3).png',
  //   title: '1-комнатная, 37,07 м²',
  //   price: '______',
  //   commonSpace: '37,07 м²',
  //   livingSpace: '16,48 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/37,31(3).png',
  //   title: '1-комнатная, 37,31 м²',
  //   price: '______',
  //   commonSpace: '37,31 м²',
  //   livingSpace: '16,73 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/37,33(2).png',
  //   title: '1-комнатная, 37,33 м²',
  //   price: '______',
  //   commonSpace: '37,33 м²',
  //   livingSpace: '16,73 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/38,02(4).png',
  //   title: '1-комнатная, 38,02 м²',
  //   price: '______',
  //   commonSpace: '38,02 м²',
  //   livingSpace: '15,51 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/38,14(4).png',
  //   title: '1-комнатная, 38,14 м²',
  //   price: '______',
  //   commonSpace: '38,14 м²',
  //   livingSpace: '12,87 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/38,15(2).png',
  //   title: '1-комнатная, 38,15 м²',
  //   price: '______',
  //   commonSpace: '38,15 м²',
  //   livingSpace: '12,87 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/38,15(3).png',
  //   title: '1-комнатная, 38,15 м²',
  //   price: '______',
  //   commonSpace: '38,15 м²',
  //   livingSpace: '12,87 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/38,37(2,1).png',
  //   title: '1-комнатная, 38,37 м²',
  //   price: '______',
  //   commonSpace: '38,37 м²',
  //   livingSpace: '15,51 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/38,37(2).png',
  //   title: '1-комнатная, 38,37 м²',
  //   price: '______',
  //   commonSpace: '38,37 м²',
  //   livingSpace: '12,87 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/38,37(3).png',
  //   title: '1-комнатная, 38,37 м²',
  //   price: '______',
  //   commonSpace: '38,37 м²',
  //   livingSpace: '12,87 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/38,38(2).png',
  //   title: '1-комнатная, 38,38 м²',
  //   price: '______',
  //   commonSpace: '38,38 м²',
  //   livingSpace: '15,52 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/38,38(3,1).png',
  //   title: '1-комнатная, 38,38 м²',
  //   price: '______',
  //   commonSpace: '38,38 м²',
  //   livingSpace: '15,52 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/38,38(3).png',
  //   title: '1-комнатная, 38,38 м²',
  //   price: '______',
  //   commonSpace: '38,38 м²',
  //   livingSpace: '15,52 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/38,38(3).png',
  //   title: '1-комнатная, 38,38 м²',
  //   price: '______',
  //   commonSpace: '38,38 м²',
  //   livingSpace: '15,52 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/39,00(4).png',
  //   title: '1-комнатная, 39,00 м²',
  //   price: '______',
  //   commonSpace: '39,00 м²',
  //   livingSpace: '14,13 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/39,64(4).png',
  //   title: '1-комнатная, 39,64 м²',
  //   price: '______',
  //   commonSpace: '39,64 м²',
  //   livingSpace: '12,87 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/39,65(2).png',
  //   title: '1-комнатная, 39,65 м²',
  //   price: '______',
  //   commonSpace: '39,65 м²',
  //   livingSpace: '12,87 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/39,65(3).png',
  //   title: '1-комнатная, 39,65 м²',
  //   price: '______',
  //   commonSpace: '39,65 м²',
  //   livingSpace: '12,87 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/39,87(2).png',
  //   title: '1-комнатная, 39,87 м²',
  //   price: '______',
  //   commonSpace: '39,87 м²',
  //   livingSpace: '12,87 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/39,87(3).png',
  //   title: '1-комнатная, 39,87 м²',
  //   price: '______',
  //   commonSpace: '39,87 м²',
  //   livingSpace: '12,87 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/39,90(2).png',
  //   title: '1-комнатная, 39,90 м²',
  //   price: '______',
  //   commonSpace: '39,90 м²',
  //   livingSpace: '15,51 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/40,01(4).png',
  //   title: '1-комнатная, 40,01 м²',
  //   price: '______',
  //   commonSpace: '40,01 м²',
  //   livingSpace: '15,51 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/40,15(3).png',
  //   title: '1-комнатная, 40,15 м²',
  //   price: '______',
  //   commonSpace: '40,15 м²',
  //   livingSpace: '15,52 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/40,17(3).png',
  //   title: '1-комнатная, 40,17 м²',
  //   price: '______',
  //   commonSpace: '40,17 м²',
  //   livingSpace: '15,52 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/40,39(2).png',
  //   title: '1-комнатная, 40,39 м²',
  //   price: '______',
  //   commonSpace: '40,39 м²',
  //   livingSpace: '15,52 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/41,41(4).png',
  //   title: '1-комнатная, 41,41 м²',
  //   price: '______',
  //   commonSpace: '41,41 м²',
  //   livingSpace: '14,31 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/41,82(4).png',
  //   title: '1-комнатная, 41,82 м²',
  //   price: '______',
  //   commonSpace: '41,82 м²',
  //   livingSpace: '12,2 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/43,68(4).png',
  //   title: '1-комнатная, 43,68 м²',
  //   price: '______',
  //   commonSpace: '43,68 м²',
  //   livingSpace: '12,2 м²',
  //   dialogTitle: 'Однокомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/1c_60,45.png',
  //   title: '2-комнатная, 60,45 м²',
  //   price: '______',
  //   commonSpace: '60,45 м²',
  //   livingSpace: '28,39 м²',
  //   dialogTitle: 'Двухкомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/2с_54,28.png',
  //   title: '2-комнатная, 54,28 м²',
  //   price: '______',
  //   commonSpace: '54,28 м²',
  //   livingSpace: '32,73 м²',
  //   dialogTitle: 'Двухкомнатная квартира',
  // },
  {
    image: '/assets/images/apartments/2с_53,67.png',
    title: '2-комнатная, 53,67 м²',
    price: '______',
    commonSpace: '53,67 м²',
    livingSpace: '31,48 м²',
    dialogTitle: 'Двухкомнатная квартира',
  },
  {
    image: '/assets/images/apartments/1с_42,78.png',
    title: '2-комнатная, 42,78 м²',
    price: '______',
    commonSpace: '42,78 м²',
    livingSpace: '22,28 м²',
    dialogTitle: 'Двухкомнатная квартира (евро)',
  },
  {
    image: '/assets/images/apartments/4с_46,08.png',
    title: '2-комнатная, 46,08 м²',
    price: '______',
    commonSpace: '46,08 м²',
    livingSpace: '26,03 м²',
    dialogTitle: 'Двухкомнатная квартира (евро)',
  },
  {
    image: '/assets/images/apartments/4с_70,94.png',
    title: '3-комнатная, 70,94 м²',
    price: '______',
    commonSpace: '70,94 м²',
    livingSpace: '40,76 м²',
    dialogTitle: 'Трехкомнатная квартира',
  },
  {
    image: '/assets/images/apartments/4с_60,76.png',
    title: '3-комнатная, 60,76 м²',
    price: '______',
    commonSpace: '60,76 м²',
    livingSpace: '39,69 м²',
    dialogTitle: 'Трехкомнатная квартира (евро)',
  },
  // {
  //   image: '/assets/images/apartments/60,18(1).png',
  //   title: '2-комнатная, 60,18 м²',
  //   price: '______',
  //   commonSpace: '60,18 м²',
  //   livingSpace: '42,07 м²',
  //   dialogTitle: 'Двухкомнатная квартира (евро)',
  // },
  // {
  //   image: '/assets/images/apartments/62,46(1).png',
  //   title: '2-комнатная, 62,46 м²',
  //   price: '______',
  //   commonSpace: '62,46 м²',
  //   livingSpace: '42,07 м²',
  //   dialogTitle: 'Двухкомнатная квартира (евро)',
  // },
  // {
  //   image: '/assets/images/apartments/66,4(1).png',
  //   title: '2-комнатная, 66,4 м²',
  //   price: '______',
  //   commonSpace: '66,4 м²',
  //   livingSpace: '40,1 м²',
  //   dialogTitle: 'Двухкомнатная квартира (евро)',
  // },
  // {
  //   image: '/assets/images/apartments/68,11(1).png',
  //   title: '2-комнатная, 68,11 м²',
  //   price: '______',
  //   commonSpace: '68,11 м²',
  //   livingSpace: '40,1 м²',
  //   dialogTitle: 'Двухкомнатная квартира (евро)',
  // },
  // {
  //   image: '/assets/images/apartments/74,62(1).png',
  //   title: '3-комнатная, 74,62 м²',
  //   price: '______',
  //   commonSpace: '74,62 м²',
  //   livingSpace: '40,1 м²',
  //   dialogTitle: 'Трехкомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/77,58(1).png',
  //   title: '3-комнатная, 77,58 м²',
  //   price: '______',
  //   commonSpace: '77,58 м²',
  //   livingSpace: '47,17 м²',
  //   dialogTitle: 'Трехкомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/78,16(1).png',
  //   title: '3-комнатная, 78,16 м²',
  //   price: '______',
  //   commonSpace: '78,16 м²',
  //   livingSpace: '50,6 м²',
  //   dialogTitle: 'Трехкомнатная квартира',
  // },
  // {
  //   image: '/assets/images/apartments/83,44(1).png',
  //   title: '3-комнатная, 83,44 м²',
  //   price: '______',
  //   commonSpace: '83,44 м²',
  //   livingSpace: '50,6 м²',
  //   dialogTitle: 'Трехкомнатная квартира',
  // },
];
